package com.fireavert.devices.data_models.response

import kotlinx.serialization.Serializable

@Serializable
data class GetDeviceRecentGatewayAssociationResponse(
    var deviceToGateway: Map<String, List<String>> = emptyMap(),

)
